var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_1186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.20828 7.16672H1.95828C1.15414 7.16672 0.5 6.51257 0.5 5.70828V1.95828C0.5 1.15414 1.15414 0.5 1.95828 0.5H8.20828C9.01257 0.5 9.66672 1.15414 9.66672 1.95828V5.70828C9.66672 6.51257 9.01257 7.16672 8.20828 7.16672ZM1.95828 1.75C1.84338 1.75 1.75 1.84338 1.75 1.95828V5.70828C1.75 5.82333 1.84338 5.91672 1.95828 5.91672H8.20828C8.32333 5.91672 8.41672 5.82333 8.41672 5.70828V1.95828C8.41672 1.84338 8.32333 1.75 8.20828 1.75H1.95828Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20828 20.5H1.95828C1.15414 20.5 0.5 19.8458 0.5 19.0417V10.2917C0.5 9.4874 1.15414 8.83325 1.95828 8.83325H8.20828C9.01257 8.83325 9.66672 9.4874 9.66672 10.2917V19.0417C9.66672 19.8458 9.01257 20.5 8.20828 20.5ZM1.95828 10.0833C1.84338 10.0833 1.75 10.1766 1.75 10.2917V19.0417C1.75 19.1566 1.84338 19.25 1.95828 19.25H8.20828C8.32333 19.25 8.41672 19.1566 8.41672 19.0417V10.2917C8.41672 10.1766 8.32333 10.0833 8.20828 10.0833H1.95828Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0417 20.5H12.7917C11.9874 20.5 11.3333 19.8458 11.3333 19.0417V15.2917C11.3333 14.4874 11.9874 13.8333 12.7917 13.8333H19.0417C19.8458 13.8333 20.5 14.4874 20.5 15.2917V19.0417C20.5 19.8458 19.8458 20.5 19.0417 20.5ZM12.7917 15.0833C12.6766 15.0833 12.5833 15.1766 12.5833 15.2917V19.0417C12.5833 19.1566 12.6766 19.25 12.7917 19.25H19.0417C19.1566 19.25 19.25 19.1566 19.25 19.0417V15.2917C19.25 15.1766 19.1566 15.0833 19.0417 15.0833H12.7917Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0417 12.1667H12.7917C11.9874 12.1667 11.3333 11.5126 11.3333 10.7083V1.95828C11.3333 1.15414 11.9874 0.5 12.7917 0.5H19.0417C19.8458 0.5 20.5 1.15414 20.5 1.95828V10.7083C20.5 11.5126 19.8458 12.1667 19.0417 12.1667ZM12.7917 1.75C12.6766 1.75 12.5833 1.84338 12.5833 1.95828V10.7083C12.5833 10.8233 12.6766 10.9167 12.7917 10.9167H19.0417C19.1566 10.9167 19.25 10.8233 19.25 10.7083V1.95828C19.25 1.84338 19.1566 1.75 19.0417 1.75H12.7917Z",
    fill: "#5E35B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_1186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard1);
export default __webpack_public_path__ + "static/media/dashboard 1.6abec8adaf5116eacafdf6f803af0b65.svg";
export { ForwardRef as ReactComponent };